export enum MessageEventEnum {
  /**
   * Message open event
   */
  open = 'open',

  /**
   * Message close event
   */
  close = 'close',
}
